/**
 * ScopeList — shared across every question screen.
 * Sticky rail on desktop, sticky footer on mobile (handled by .flow__rail CSS).
 * Shows the plain-language scope building up as the customer answers.
 *
 * Never renders prices, crew-days, costs, or module internals — scope only.
 */
import type { CustomerEstimateItem } from '../lib/types';

interface ScopeListProps {
  items: CustomerEstimateItem[];
  /** Hero variant for the F7 reveal (dark surface, larger heading). */
  variant?: 'card' | 'hero';
}

export function ScopeList({ items, variant = 'card' }: ScopeListProps): JSX.Element {
  const heading = variant === 'hero' ? 'YOUR PROJECT' : "WHAT WE'RE QUOTING";

  return (
    <div className={variant === 'hero' ? 'estimate estimate--hero' : 'estimate'}>
      <div className="estimate__label">{heading}</div>
      {items.length === 0 ? (
        <div className="estimate__hint">Your scope builds as you answer.</div>
      ) : (
        <ul className="scope-list">
          {items.map((item, i) => (
            // Plain-language scope only — no quantities. The raw derived counts
            // (SF/room math) are internal and can be imprecise; the customer
            // shouldn't see them.
            <li key={`${item.name}-${i}`} className="scope-list__item">
              {item.name}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
